import styled from 'styled-components';

export const Toggle = styled.div`
  display: flex;

  .toggle-switch {
    position: relative;
    min-width: 1.75rem;
    display: inline-block;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    text-align: left;
    height: 1.125rem;

    &-checkbox {
      display: none;
    }

    &-label {
      display: block;
      overflow: hidden;
      cursor: pointer;
      border: 0 solid #bbb;
      border-radius: 20px;
      margin: 0;
      height: 100%;
    }

    &-inner {
      display: block;
      width: 200%;
      margin-left: 0;
      transition: margin 0.3s ease-in 0s;
      &:before,
      &:after {
        display: block;
        float: left;
        width: 50%;
        height: 34px;
        padding: 0;
        line-height: 34px;
        font-size: 14px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
      }

      &:before {
        content: '';
        text-transform: uppercase;
        padding-left: 10px;
        background-color: #fff;
        color: #fff;
      }
    }

    &-inner:after {
      content: '';
      text-transform: uppercase;
      padding-right: 12px;
      color: #fff;
      text-align: right;
    }

    &-inner.toggle-green:after {
      background-color: #42a262;
    }

    &-inner.toggle-blue:after {
      background-color: #0072b7;
    }

    &-switch {
      display: block;
      width: 8px;
      height: 8px;
      position: absolute;
      top: 5px;
      bottom: 0;
      border-radius: 20px;
      transition: all 0.3s ease-in 0s;
    }
  }
`;
